import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index/index'
import personalCenter from '../views/personalCenter/personalCenterHome'
import shopcarIndex from '../views/shopcar/shopcarOne'
import helpindex from '../views/help/helpIndex'

Vue.use(VueRouter)

const routes = [{
    path: '*',
    redirect: '/index'
}, {
    path: '/index',
    name: 'index',
    meta: {
        requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的

    },
    redirect: '/indexinner',
    component: index,
    children: [{
        // 商品页
        name: 'indexinner',
        path: '/indexinner',
        component: () =>
            import('../views/index/indexinner/indexinner'),
        children: []
    },
    {
        // 商品查看更多
        name: 'seemore',
        path: '/seemore',
        component: () =>
            import('../views/index/indexseemore/seemore'),
        meta: {
            keepAlive: true,  // 需要缓存
        }
    },
    {
        // 商品查看更多
        name: 'newlist',
        path: '/newlist',
        component: () =>
            import('../views/index/indexseemore/newlist')
    },
    {
        // 疯狂抢购
        name: 'seckill',
        path: '/seckill',
        component: () =>
            import('../views/index/indexseckill/seckill')
    },
    {
        // 限时促销
        name: 'seckills',
        path: '/seckills',
        component: () =>
            import('../views/index/indexseckills/seckill')
    },
    {
        // 开学必备
        name: 'schollopen',
        path: '/schollopen',
        component: () =>
            import('../views/index/indexschollopen/indexscholl')
    },
    {
        //品牌馆
        name: 'brand',
        path: '/brand',
        component: () =>
            import('../views/index/indexbrand/brand')
    },
    {
        //品牌馆
        name: 'changjing',
        path: '/changjing',
        component: () =>
            import('../views/index/changjing/brand')
    },
    {
        //品牌馆详情
        name: 'brandinner',
        path: '/brandinner',
        component: () =>
            import('../views/index/indexbrand/brandinner')
    },
    {
        //商品详情
        name: 'details',
        path: '/details',
        component: () =>
            import('../views/shopdetails/details'),

        redirect: '/introduce',
        children: [{
            //产品介绍
            name: 'introduce',
            path: '/introduce',

            component: () =>
                import('../views/shopdetails/compontsdetails/introduce')
        },


        {
            //产品规格
            name: 'Specifications',
            path: '/Specifications',
            component: () =>
                import('../views/shopdetails/compontsdetails/Specifications')

        }]
    },
    {
        //商品活动详情
        name: 'huodongdetails',
        path: '/huodongdetails',
        component: () =>
            import('../views/shopdetails/huodongdetails'),
        redirect: '/huodongintroduce',

        children: [{
            //产品介绍
            name: 'huodongintroduce',
            path: '/huodongintroduce',

            component: () =>
                import('../views/shopdetails/compontsdetails/introduce')
        }, {
            //产品规格
            name: 'huodongSpecifications',
            path: '/huodongSpecifications',

            component: () =>
                import('../views/shopdetails/compontsdetails/Specifications')

        }]
    }
    ]
},
{
    path: '/login',
    name: 'login',
    component: () =>
        import('../views/login/login')
}, {
    path: '/register',
    name: 'register',
    component: () =>
        import('../views/login/register')
}, {
    path: '/registermima',
    name: 'registermima',
    component: () =>
        import('../views/login/registermima')
}, {
    path: '/personalCenter',
    name: 'personalCenter',
    redirect: '/personalHome',
    component: personalCenter,

    children: [
        {
            // 代付
            name: 'daifu',
            path: '/daifu',
            component: () =>
                import('../views/personalCenter/daifu/daifu'),
            children: []
        },
        {
            // 代付订单
            name: 'daifuOrder',
            path: '/daifuOrder',
            component: () =>
                import('../views/personalCenter/daifu/daifuOrder'),
            children: []
        }, {
            // 个人中心首页
            name: 'personalHome',
            path: '/personalHome',
            component: () =>
                import('../views/personalCenter/personalHome/personalHome'),
            children: []
        }, {
            // 个人中心账户管理-基本信息
            name: 'personalaccount',
            path: '/personalaccount',
            component: () =>
                import('../views/personalCenter/personalAccount/personalAccount'),
            children: []
        }, {
            // 个人中心账户管理-采购审批
            name: 'personalProcurement',
            path: '/personalProcurement',
            component: () =>
                import('../views/personalCenter/personalAccount/personalProcurement'),
            children: []
        }, {
            // 个人中心账户管理-采购审批-审批
            name: 'personalProcurements',
            path: '/personalProcurements',
            component: () =>
                import('../views/personalCenter/personalAccount/personalProcurements'),
            children: []
        }, {
            // 个人中心账户管理-手机绑定
            name: 'personalPhone',
            path: '/personalPhone',
            component: () =>
                import('../views/personalCenter/personalAccount/personalPhone'),
            children: []
        }, {
            // 个人中心账户管理-微信绑定
            name: 'personalWechart',
            path: '/personalWechart',
            component: () =>
                import('../views/personalCenter/personalAccount/personalWechart'),
            children: []
        }, {
            // 个人中心账户管理-邮箱绑定
            name: 'personalEmail',
            path: '/personalEmail',
            component: () =>
                import('../views/personalCenter/personalAccount/personalEmail'),
            children: []
        }, {
            // 个人中心账户管理-修改密码
            name: 'personalXg',
            path: '/personalXg',
            component: () =>
                import('../views/personalCenter/personalAccount/personalXg'),
            children: []
        }, {
            // 个人中心账户管理-新增地址
            name: 'personalAddress',
            path: '/personalAddress',
            component: () =>
                import('../views/personalCenter/personalAccount/personalAddress'),
            children: []
        }, {
            // 个人中心账户管理-采购员管理
            name: 'personalCgr',
            path: '/personalCgr',
            component: () =>
                import('../views/personalCenter/personalAccount/personalCgr'),
            children: []
        }, {
            // 个人中心-我的收藏
            name: 'personaCollection',
            path: '/personaCollection',
            component: () =>
                import('../views/personalCenter/personalHome/personaCollection'),
            children: []
        }, {
            // 个人中心-浏览历史
            name: 'personalHistory',
            path: '/personalHistory',
            component: () =>
                import('../views/personalCenter/personalHome/personalHistory'),
            children: []
        }, {
            // 个人中心-我的积分
            name: 'personalIntegral',
            path: '/personalIntegral',
            component: () =>
                import('../views/personalCenter/personalHome/personalIntegral'),
            children: []
        }, {
            // 个人中心-我的红包
            name: 'personalPackage',
            path: '/personalPackage',
            component: () =>
                import('../views/personalCenter/personalHome/personalPackage'),
            children: []
        }, {
            // 个人中心-发票管理
            name: 'personalTicket',
            path: '/personalTicket',
            component: () =>
                import('../views/personalCenter/personalHome/personalTicket'),
            children: []
        }, {
            // 个人中心-发票关联订单
            name: 'personalTickets',
            path: '/personalTickets',
            component: () =>
                import('../views/personalCenter/personalHome/personalTickets'),
            children: []
        }, {
            // 个人中心-申请开票
            name: 'personalTicketopen',
            path: '/personalTicketopen',
            component: () =>
                import('../views/personalCenter/personalHome/personalTicketopen'),
            children: []
        }, {
            // 个人中心-申请开票-验证
            name: 'personalTicketYz',
            path: '/personalTicketYz',
            component: () =>
                import('../views/personalCenter/personalHome/personalTicketYz'),
            children: []
        }, {
            // 个人中心-订单管理
            name: 'personalOrder',
            path: '/personalOrder',
            component: () =>
                import('../views/personalCenter/personalHome/personalOrder'),
            children: []
        },
        {
            // 个人中心-待付款
            name: 'personalObligation',
            path: '/personalObligation',
            component: () =>
                import('../views/personalCenter/personalHome/personalObligation'),
            children: []
        }, {
            // 个人中心-评价
            name: 'personalevaluation',
            path: '/personalevaluation',
            component: () =>
                import('../views/personalCenter/personalHome/personalevaluation'),
            children: []
        }, {
            // 个人中心-评价
            name: 'personalevaluations',
            path: '/personalevaluations',
            component: () =>
                import('../views/personalCenter/personalHome/personalevaluations'),
            children: []
        }, , {
            // 个人中心-评价查看
            name: 'personalevaluationslook',
            path: '/personalevaluationslook',
            component: () =>
                import('../views/personalCenter/personalHome/personalevaluationslook'),
            children: []
        }, {
            // 个人中心-申请售后
            name: 'personalAftersale',
            path: '/personalAftersale',
            component: () =>
                import('../views/personalCenter/personalHome/personalAftersale'),
            children: []
        }, {
            // 个人中心-申请售后
            name: 'personalservice',
            path: '/personalservice',
            component: () =>
                import('../views/personalCenter/personalHome/personalservice'),
            children: []
        }, {
            // 个人中心-申请售后-订单列表页
            name: 'personalservicelist',
            path: '/personalservicelist',
            component: () =>
                import('../views/personalCenter/personalHome/personalservicelist'),
            children: []
        }, {
            // 个人中心-申请售后-创建售后订单
            name: 'personalservicecreate',
            path: '/personalservicecreate',
            component: () =>
                import('../views/personalCenter/personalHome/personalservicecreate'),
            children: []
        }, {
            // 个人中心-申请售后-查看售后订单
            name: 'personalservicelook',
            path: '/personalservicelook',
            component: () =>
                import('../views/personalCenter/personalHome/personalservicelook'),
            children: []
        }, {
            // 个人中心-申请退款
            name: 'personaltuikuan',
            path: '/personaltuikuan',
            component: () =>
                import('../views/personalCenter/personalHome/personaltuikuan'),
            children: []
        }, {
            // 个人中心-确认收货
            name: 'personalqueren',
            path: '/personalqueren',
            component: () =>
                import('../views/personalCenter/personalHome/personalqueren'),
            children: []
        }, {
            // 个人中心-资讯站内信列表
            name: 'personalinforlist',
            path: '/personalinforlist',
            component: () =>
                import('../views/personalCenter/personalHome/personalinforlist'),
            children: []
        },
        {
            // 个人中心-资讯详情
            name: 'personalinformation',
            path: '/personalinformation',
            component: () =>
                import('../views/personalCenter/personalHome/personalinformation'),
            children: []
        },
        {
            // 个人中心-账户余额
            name: 'zhyue',
            path: '/zhyue',
            component: () =>
                import('../views/personalCenter/zhyue'),
            children: []
        },
        {
            // 个人中心-余额充值
            name: 'yuechongzhi',
            path: '/yuechongzhi',
            component: () =>
                import('../views/personalCenter/yuechongzhi'),
            children: []
        },
    ]

}, {
    path: '/shopcarIndex',
    name: 'shopcarIndex',


    redirect: '/shopcarList',
    component: shopcarIndex,

    children: [{
        // 购物车列表
        name: 'shopcarList',
        path: '/shopcarList',
        component: () =>
            import('../views/shopcar/shopcarList'),
        children: []
    }, {
        // 购物车填写订单
        name: 'shopcarContent',
        path: '/shopcarContent',
        component: () =>
            import('../views/shopcar/shopcarContent'),
        children: []
    }, {
        // 购物车结果
        name: 'shopcarResult',
        path: '/shopcarResult',
        component: () =>
            import('../views/shopcar/shopcarResult'),
        children: []
    }


    ]

},
{
    path: '/helpindex',
    name: 'helpindex',
    redirect: '/helplist',
    component: helpindex,
    children: [{
        // 帮助中心
        name: 'helplist',
        path: '/helplist',
        component: () =>
            import('../views/help/components/helplist'),
        children: []
    }]

}
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        // return 期望滚动到哪个的位置
        return { x: 0, y: 0 }
    }
})

export default router